import { render, staticRenderFns } from "./Tariffs.vue?vue&type=template&id=40023b07&scoped=true&"
import script from "./Tariffs.vue?vue&type=script&lang=js&"
export * from "./Tariffs.vue?vue&type=script&lang=js&"
import style0 from "./Tariffs.vue?vue&type=style&index=0&id=40023b07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40023b07",
  null
  
)

export default component.exports